import http from "../helpers/http-common";

class MediaDataService {
    getAll(params) {
        return http.get("/media/all", { params });
    }

    getInvalid(params) {
        return http.get("/media/invalid", { params });
    }

    markAsVerified(mediaId, params) {
        return http.post(`/media/${mediaId}/markAsVerified`, params);
    }

    getAllSpecialsUsers(params) {
        return http.post(`/media/specials`, params);
    }
    getAllFeaturedToCheck(params) {
        return http.post("/media/checkFeatured",  params);
    }

    markAsFeatured(params) {
        return http.post(`/media/markAsFeatured`, params);
    }

    markAsScoreVerified(params) {
        return http.post(`/media/markAsScoreVerified`, params);
    }

    archiveMedia(params) {
        return http.post('/media/archiveMedia', params);
    }

    reimportMedia(params) {
        return http.post('/media/reimportMedia', params);
    }

    generateFaceThumbnail(params) {
        return http.post('media/generateFaceThumbnail', params);
    }

    keepOldThumbnail(params) {
        return http.post('media/keepOldThumbnail', params);
    }

    keepNewThumbnail(params) {
        return http.post('media/keepNewThumbnail', params);
    }

    get(mediaId) {
        return http.get(`/media/${mediaId}`);
    }

    getModerationMedia(params) {
        return http.post(`/media/moderation-valided`, params);
    }

    getModerationMediaScored(params) {
        return http.post(`/media/moderation-scored`, params);
    }

    getModerationMediaDeleted(params) {
        return http.post(`/media/moderation-deleted`, params);
    }
}

export default new MediaDataService();
